import React from 'react';
import Grid from '@material-ui/core/Grid';
import Comma from "../../../assets/images/comma.png";
import {leaderBoard} from "../../../Utility/Url";
import Shadow from '../Common/Shadow'
import {withRouter} from "react-router-dom";

class League extends React.Component{
    constructor() {
        super();
    }
    componentDidMount() {
    }
    render() {
        const {
            id,
            name,
            yourPlace,
            icon,
            placeholder,
            firstColor,
            fontColor,
            hasTwoValues,
            prevID,
            secondColor}=this.props.data
        return(
            <Grid className='winners-table-league' justify={"center"} alignItems={"flex-start"} item container
                  style={{
                    color:fontColor,
            }}>
                <Grid item sm={12} xs={12}  alignItems={"center"} container justify={"center"} direction={"column"} className='winners-table-league-gradient'
                      style={{background:`linear-gradient(${firstColor}, ${secondColor})`, color:fontColor}}>
                    <Grid style={{position:'relative',height:'20%'}} direction={"row-reverse"} justify={"space-around"} item container>
                        <Shadow/>
                    </Grid>
                    {/*<Grid container alignItems={"center"} justify={"center"}*/}
                    {/*      style={{*/}
                    {/*          background:'red',*/}
                    {/*          zIndex:'2000'*/}
                    {/*        }}*/}
                    {/*      >*/}
                        <Grid item container justify={"center"}>
                            <Grid container xs={3} sm={3} justify={"center"}>
                                <img src={icon}  alt=""/>
                            </Grid>
                        </Grid>
                        <Grid item container justify={"center"}>
                            <p className='winners-table-league-title-text'>
                                {name}
                            </p>
                        </Grid>
                        <Grid item container justify={"center"} alignItems={"center"} style={{position:'relative'}}>
                            {/*<img src={placeholder} style={{width:'80%'}} alt=""/>*/}
                            <Grid container xs={11} sm={11} justify={"center"} style={{
                                backgroundImage:`url(${placeholder})`,
                                backgroundSize:'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition:'center',
                                // position:'absolute'
                            }}
                            >
                                <Grid item sm={4} xs={4}>
                                    <p className='winners-table-league-rank-section-text'>
                                        رتبه شما :
                                    </p>
                                </Grid>
                                <Grid item sm={4} xs={4}>
                                    <p className='winners-table-league-rank-section-rank'>
                                        {yourPlace}
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>
                    {/*</Grid>*/}
                </Grid>
                {
                    !hasTwoValues &&
                    <Grid item sm={12} xs={12} container justify={"space-around"} style={{margin:'20px 0'}}>
                        <Grid
                            className={'winners-table-league-button clickable'}

                            justify={"center"} item sm={11} xs={11} style={{backgroundColor:'#266696',borderColor:'#89b5e2'}}
                              onClick={()=>{
                                  this.props.history.push(`winners-table/${id}`)
                              }}
                        >
                            <p>
                                جاری
                            </p>
                        </Grid>
                    </Grid>
                }
                {
                    hasTwoValues &&
                    <Grid item sm={12} xs={12} container justify={"space-around"} style={{margin:'20px 0'}}>
                        <Grid
                            className={"winners-table-league-button " + (id==0 ? 'disable ' : 'clickable')}

                            justify={"center"} item sm={5} xs={5} style={{backgroundColor:'#266696',borderColor:'#89b5e2'}}
                            onClick={()=>{
                                if (id!=0)
                                  this.props.history.push(`/winners-table/${id}`)
                            }}
                        >
                            <p>
                                جاری
                            </p>
                        </Grid>
                        <Grid className='winners-table-league-button clickable' justify={"center"} item sm={5} xs={5}
                              style={{backgroundColor:'#266696',borderColor:'#89b5e2'}}
                              onClick={()=>{
                                  if (hasTwoValues && prevID!=='')
                                      this.props.history.push(`/winners-table/${prevID}`)
                              }}
                        >
                            <p>
                                قبلی
                            </p>
                        </Grid>
                    </Grid>
                }
                </Grid>
        )
    }
}
export default withRouter (League)